module.exports = __webpack_public_path__ + "static/media/logo5.3057a3f4.png";